import React from 'react'

function Rotate() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <g fill="currentColor" clipPath="url(#clip0_1288_1921)">
                <path d="M8.053 14.666A5.333 5.333 0 118.053 4a.16.16 0 01.114.273L6.913 5.526a.667.667 0 00.474 1.14.667.667 0 00.473-.193l2.667-2.667a.666.666 0 000-.946L7.86.193a.67.67 0 10-.947.947l1.254 1.253a.16.16 0 01-.114.273 6.667 6.667 0 100 13.334.666.666 0 100-1.334zM11.267 13.594c-.357.266-.744.49-1.153.666a.667.667 0 00-.209 1.09.666.666 0 00.729.143c.51-.215.991-.492 1.433-.826a.666.666 0 10-.8-1.067v-.006zM14.073 9.82a.667.667 0 00-.78.526c-.091.463-.244.911-.453 1.334a.667.667 0 101.2.586c.259-.528.447-1.089.56-1.666a.666.666 0 00-.527-.78zM14.06 8.713a.667.667 0 00.507-.794 6.567 6.567 0 00-.627-1.72.666.666 0 10-1.173.627c.226.434.394.896.5 1.373a.668.668 0 00.793.514z"></path>
            </g>
            <defs>
                <clipPath id="clip0_1288_1921">
                    <path fill="currentColor" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export default Rotate
